export const selectFilterHandler = (filter, fieldName, value) => {
  if (!value) return delete filter.current[fieldName]
  filter.current[fieldName] = value
}
